var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDeactivateChargePoint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 75.5,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 75.5,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 75C15 41.8629 41.8629 15 75 15C108.137 15 135 41.8629 135 75C135 108.137 108.137 135 75 135C41.8629 135 15 108.137 15 75Z",
    fill: "#F8696E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 74.625C107.915 80.7188 106.434 86.1777 103.557 91.002C100.679 95.9108 96.7858 99.804 91.877 102.682C87.0527 105.559 81.5938 107.04 75.5 107.125C69.4062 107.04 63.9473 105.559 59.123 102.682C54.2142 99.804 50.321 95.9108 47.4434 91.002C44.5658 86.1777 43.0846 80.7188 43 74.625C43.0846 68.5312 44.5658 63.0723 47.4434 58.248C50.321 53.3392 54.2142 49.446 59.123 46.5684C63.9473 43.6908 69.4062 42.2096 75.5 42.125C81.5938 42.2096 87.0527 43.6908 91.877 46.5684C96.7858 49.446 100.679 53.3392 103.557 58.248C106.434 63.0723 107.915 68.5312 108 74.625ZM55.6953 60.5332C52.7331 64.5957 51.2096 69.293 51.125 74.625C51.2943 81.5651 53.6641 87.3203 58.2344 91.8906C62.8047 96.4609 68.5599 98.8307 75.5 99C80.832 98.9154 85.5293 97.4342 89.5918 94.5566L55.6953 60.5332ZM99.875 74.625C99.7057 67.6849 97.3359 61.9297 92.7656 57.3594C88.1953 52.7891 82.4401 50.4193 75.5 50.25C70.168 50.3346 65.4707 51.8581 61.4082 54.8203L95.4316 88.7168C98.3092 84.6543 99.7904 79.957 99.875 74.625Z",
    fill: "url(#paint0_linear_150_2744)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_2744",
    x1: 64.4732,
    y1: 37.9375,
    x2: 64.4732,
    y2: 107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260076,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeactivateChargePoint);
export default __webpack_public_path__ + "static/media/img_deactivate_charge_point.f42cbaa32e89b37e750ac5dd55fe441a.svg";
export { ForwardRef as ReactComponent };